import { Injectable } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { select, Store } from '@ngrx/store';

import { OnFieldChanged } from '@ordersnproducts/modules/shared/modules/configurable-form/models/on-field-changed';
import { OrderBuilderState } from '@ordersnproducts/modules/order-builder/reducers';
import { SpecFieldNames } from '@ordersnproducts/modules/order-builder/modules/specification/constants/specification-field-names.enum';
import { filter, take, map } from 'rxjs/operators';
import { getTemperatureVaps } from '../../../../selectors/added-value.selectors';
import { ValueAddedsSpecalizedActionOP } from '../../../../actions/open-platform/added-values.actions';
import { _safe } from '@ordersnproducts/modules/shared/utils/safe-get.method';
import { ConfigurableFormComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/containers/configurable-form/configurable-form.component';
import { FieldConfig } from '@ordersnproducts/modules/shared/modules/configurable-form/models/field-configs/field-config.interface';

@Injectable()
export class ValidateTemperatureValueSpecializedCommandService implements OnFieldChanged {
  constructor(private store: Store<OrderBuilderState>) {}

  onFieldChanged(
    value: string,
    formGroup: UntypedFormGroup,
    form: ConfigurableFormComponent,
    config: FieldConfig,
  ): void {
    const formControl = formGroup.get(config.name);
    const formId = formGroup.get(SpecFieldNames.ID).value;
    const specialized$ = this.store.pipe(
      select(getTemperatureVaps),
      filter((state) => {
        return !!_safe(() => state[formId][0]);
      }),
      map((tuples) => {
        if (!!tuples && !!value && tuples[0].length > 0) {
          const specialized = _safe(() => tuples[0].find((item) => item.valueAddedCode === value).isSpecialized);
          const hasNotAllowedCombinations = _safe(
            () => tuples[0].find((item) => item.valueAddedCode === value)['hasNotAllowedCombinations'],
          );
          if (specialized || hasNotAllowedCombinations === false) {
            this.store.dispatch(
              new ValueAddedsSpecalizedActionOP({
                formdId: formId,
                specialized: specialized,
                nothasNotAlloedCombinations: hasNotAllowedCombinations === false,
              }),
            );
          } else {
            this.store.dispatch(
              new ValueAddedsSpecalizedActionOP({
                formdId: formId,
                specialized: false,
                nothasNotAlloedCombinations: false,
              }),
            );
          }
        } else {
          this.store.dispatch(
            new ValueAddedsSpecalizedActionOP({
              formdId: formId,
              specialized: false,
              nothasNotAlloedCombinations: false,
            }),
          );
        }
      }),
      take(1),
    );
    if (formControl && formControl.dirty) {
      specialized$.subscribe();
    }
  }
}
